import React,{useState} from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Logo from '../../../assest/images/logo.png';
import { Link, useNavigate } from 'react-router-dom';
import FooterStyle from '../../Styles/Footer.module.css';
import Button from '../../Styles/Button.module.css';
import { FaFacebookF, FaTwitter, FaLinkedinIn  } from "react-icons/fa";
import { ImInstagram } from "react-icons/im";
import constants from "../../../services/constants";
import LoginPopup from "../Login/UserLogin";
import { useSelector } from "react-redux";

const Footer =()=>{
    const { isAuthenticated, user, token } = useSelector((state) => state.auth);
    const [loginShow, setLoginShow] = useState(false);
     const navigate = useNavigate();

    const loginShowHandler = ()=>{
        setLoginShow(true)
    }
    const loginCloseHandler = ()=>{
        setLoginShow(false)
       
    }
    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent default form submission
        setLoading(true); // Show loading state
        const form = e.target; // Reference to the form
       
        // Use FormData to get form values
        const formData = new FormData(e.target);
        const Email = formData.get("email"); // Get email using the "name" attribute

        try {
            const response = await fetch(`${constants.API_BASE_URL}subsribe`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ Email }),
            });

            const data = await response.json();

            if (response.ok) {
                setResponseMessage("Sign-up successful!");
                form.reset();
            } else {
                setResponseMessage(data.error || "Something went wrong!");
            }
        } catch (error) {
            setResponseMessage("An error occurred. Please try again later.");
        } finally {
            setLoading(false); // Hide loading state
        }
    };

    const smoothScroll = () => {
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      };    

    return(
        <footer>
            <div className={FooterStyle.innerRow}>
                <Container>
                    <Row>
                        <Col md={2} className={FooterStyle.tabWidth}>
                            <div className={FooterStyle.maadfooter}>
                                <Link to="/"><img className={FooterStyle.footerLogo} src={Logo} /></Link>
                                <ul className={FooterStyle.social}>
                                    <li><Link to="https://www.facebook.com/MayoAlumniDelhi/" target="_blank"><FaFacebookF className={FooterStyle.icon} /></Link></li>
                                    <li><Link to="https://x.com/MayoAlumniDelhi/status/1603403861942755328" target="_blank"><FaTwitter className={FooterStyle.icon} /></Link></li>
                                    <li><Link to="https://in.linkedin.com/school/mayoalumni/" target="_blank"><FaLinkedinIn className={FooterStyle.icon}  /></Link></li>
                                    <li><Link to="https://www.instagram.com/mayo.alumni/?hl=en" target="_blank"><ImInstagram className={FooterStyle.icon} /></Link></li>
                                </ul>
                            </div>
                        </Col>
                        <Col md={3} className={FooterStyle.tabWidth}>
                            <div className={FooterStyle.addressInfo}>
                                <p>Mayo College Alumni Association, Delhi</p>
                                <address><b>Registered Address -</b> <span> C 39, Niti Bagh, New Delhi - 110049</span><b>Correspondence  Address -</b> 508, 5th floor, Akashdeep Building, Barakhamba Road,<span> New Delhi - 110001, India</span></address>
                                <p>Phone : <a href="tel:+91 - 11 - 23351880">+91 - 11 - 23351880</a></p>
                                <p>Email : <a href="mailto:info@mayoalumi.in">info@mayoalumi.in</a></p>
                            </div>
                        </Col>
                        <Col md={3} className={FooterStyle.tabWidth}>
                            <div className={FooterStyle.footerLink + ' ' + FooterStyle.firstLink}>
                                <ul>
                                    <li><Link onClick={smoothScroll} to="/alumni-directory">Alumni Directory</Link></li>
                                    <li><Link onClick={smoothScroll} to="/business-directories">Business Directory</Link></li>
                                    <li><Link onClick={smoothScroll} to="/offers">Offers</Link></li>
                                    <li><Link onClick={smoothScroll} to="/jobs">Job Oportunities</Link></li>
                                    <li><Link onClick={smoothScroll} to="/events">Events</Link></li>
                                    <li><Link onClick={smoothScroll} to="/news">News</Link></li>
                                    {!isAuthenticated ?
                                        <>
                                        <li><button type="button" onClick={loginShowHandler}>Log In</button></li>
                                        <li><Link onClick={smoothScroll} to="/registration">Register Now</Link></li>
                                        </>
                                        :
                                        null
                                    }
                                </ul>
                            </div>
                            <div className={FooterStyle.footerLink + ' ' + FooterStyle.lastLink}>
                                <ul>
                                    <li><Link onClick={smoothScroll} to="/about-MAAD">About MAAD</Link></li>
                                    <li><Link onClick={smoothScroll} to="/about-mayo">About MAYO</Link></li>
                                    <li><Link onClick={smoothScroll} to="/contact">Contact Us</Link></li>
                                    <li><Link onClick={smoothScroll} to="/security-information">Security Information</Link></li>
                                    <li><Link onClick={smoothScroll} to="/regulatory-information">Regulatory Information</Link></li>
                                    <li><Link onClick={smoothScroll} to="/terms-conditions">Terms &amp; Conditions</Link></li>
                                    <li><Link onClick={smoothScroll} to="/refund-policy">Refund Policy</Link></li>
                                    <li><Link onClick={smoothScroll} to="/privacy-policy">Privacy Policy</Link></li>
                                    <li><Link onClick={smoothScroll} to="/disclaimer">Disclaimer</Link></li>
                                </ul>                                
                            </div>
                        </Col>
                        <Col md={4} className={FooterStyle.tabWidth}>
                            <div className={FooterStyle.downloadMaad}>
                                <h4>Download Mayo Alumni App</h4>
                                <div className={FooterStyle.appLink}>
                                    <a target="_blank" href="https://play.google.com/store/apps/details?id=com.mayoAlumni&amp;hl=en&amp;gl=US">
                                        <img src={require('../../../assest/images/image-64@2x.png')} alt="Mayo"/>
                                    </a>
                                    <a target="_blank" href="https://apps.apple.com/in/app/mayo-alumni/id1582984503">
                                    <img src={require('../../../assest/images/image-63@2x.png')} alt="Mayo"/>
                                    </a>
                                    
                                </div>
                                <h4>Newsletter Subscription</h4>
                                <form onSubmit={handleSubmit}>
                                        <input
                                             type="email"
                                             name="email" // Use the "name" attribute
                                             placeholder="Email ID"
                                             className={FooterStyle.emailId}
                                             required
                                        />
                                        <input
                                            type="submit"
                                            value={loading ? "Signing Up..." : "Sign Up"}
                                            className={FooterStyle.submitBtn}
                                            disabled={loading} // Disable button while loading
                                        />
                                        {responseMessage && <p>{responseMessage}</p>} {/* Display response message */}
                                    </form>
                                <div className={FooterStyle.maadBtn}>
                                {!isAuthenticated ?
                                    <>
                                        <button type="button" onClick={loginShowHandler} className={Button.greenBtn}>BECOME A MEMBER</button>
                                        <button type="button" onClick={loginShowHandler} className={Button.greenBtn}>DONATE</button>
                                    </>
                                    :
                                    <>
                                        <Link to="/membership" className={Button.greenBtn}>BECOME A MEMBER</Link>
                                        <Link to="/donate" className={Button.greenBtn}>DONATE</Link>
                                    </>
                                }
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className={FooterStyle.colouredBoxes}>
                <div className={FooterStyle.line + ' ' + FooterStyle.redColor}></div>
                <div className={FooterStyle.line + ' ' + FooterStyle.yelloecolor}></div>
                <div className={FooterStyle.line + ' ' + FooterStyle.bluecolor}></div>
                <div className={FooterStyle.line + ' ' + FooterStyle.whitecolor}></div>
                <div className={FooterStyle.line + ' ' + FooterStyle.greencolor}></div>
            </div>
            <div className={FooterStyle.topSpace}>
                <Container>
                    <Row>
                        <Col className={FooterStyle.copyText}>
                            <p>© mayo college alumni association, Delhi. all rights reserved</p>
                            <p>Website Designed & Developed By : <img className={FooterStyle.logo} src={require('../../../assest/images/logo@2x.png')}  /></p>
                        </Col>
                    </Row>
                </Container>
            </div>
            {loginShow && <LoginPopup onClose={loginCloseHandler} />}
        </footer>
    )
}

export default Footer;